import { z } from "zod";

export const departmentFormValidation = z.object({
  nameAr: z
    .string()
    .trim()
    .min(2, { message: "الاسم العربي يجب أن يكون حرفين على الأقل" })
    .max(100, { message: "الاسم العربي يجب أن يكون أقل من 100 حرف" }),
  name: z
    .string()
    .trim()
    .min(2, { message: "الاسم الإنجليزي يجب أن يكون حرفين على الأقل" })
    .max(100, { message: "الاسم الإنجليزي يجب أن يكون أقل من 100 حرف" }),
  code: z
    .string()
    .trim()
    .min(2, { message: "الرمز يجب أن يكون حرفين على الأقل" })
    .max(20, { message: "الرمز يجب أن يكون أقل من 20 حرف" }),
  description: z.string().trim().max(500).optional(),
  requiresApproval: z.boolean(),
  isActive: z.boolean(),
  parentId: z.string().optional(),
});

export type DepartmentFormValues = z.infer<typeof departmentFormValidation>;
